import axios from 'axios'
import { host } from '../config/env'

/**
 * 获取当前用户信息
 */
function getUserInfo (ignoreInterceptor = false) {
  return axios.get(`${host.passport}/account/info?t=${Date.now()}`, {
    ignoreInterceptor
  })
}

/**
 * 获取当前用户手机号
 */
function getUserPhone (userId) {
  return axios.get(`${host.passport}/user/phone/bind/check?userId=${userId}`)
}

/**
 * 退出登录
 */
function logout () {
  return axios.get(`${host.service}/logout`)
}

/**
 * 获取当前用户在商城中的状态
 */
function getUserInMallStatus () {
  return axios.get(`${host.morder}/api/member/in-mall-status?t=${Date.now()}`)
}

// 用户领取福利
function receiveBenefits (activityId) {
  return axios({
    baseURL: host.iom,
    method: 'post',
    url: '/m/iom/voucher/obtain',
    headers: {
      'content-type': 'application/x-www-form-urlencoded; charset=UTF-8'
    },
    data: { activityId }
  })
}

export {
  getUserInfo,
  getUserPhone,
  logout,
  getUserInMallStatus,
  receiveBenefits
}
